import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type MetricsService from 'garaje/services/metrics';

interface ViewProfileLinkSignature {
  Args: {
    visitorId: string;
    from: string;
    id: string;
  };
}

export default class ViewProfileLink extends Component<ViewProfileLinkSignature> {
  @service declare metrics: MetricsService;

  trackViewProfileLinkClick = (): void => {
    this.metrics.trackEvent('Visitors Profiles View Profile Link Click', {
      visitor_profile_id: this.args.visitorId,
      from: this.args.from,
      id: this.args.id,
    });
  };

  <template>
    <LinkTo
      ...attributes
      @route="visitors.profiles.show"
      @model={{@visitorId}}
      @query={{hash from=@from id=@id}}
      {{on "click" this.trackViewProfileLinkClick}}
      class="btn btn--small btn--outlineFill"
      data-test-view-profile-link
    >
      View Profile
    </LinkTo>
  </template>
}
